import React, { useState, useEffect, useMemo } from 'react';
import './style.scoped.css';
import Toolbar from 'src/components/Toolbar';
import TabBar from 'src/components/TabBar';
import InfoItem from 'src/components/InfoItem';
import PolicyCard from 'src/components/PolicyCard';

import { useHistory } from 'react-router-dom';
import UserInfoService from 'src/utils/UserInfoService';
import { useTranslation } from 'react-i18next';
import policySt, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';

const CARD_DETAILS = ['assuredName', 'sumAssured', 'polStatrtDat', 'policyTerm', 'payFrequency', 'periodicPremium', 'agentName', 'agentPhone', 'agentCode'];

interface MyPolicyObserverProps {
  policyStore?: PolicyStore;
}
const MyPolicyObserver = observer(({ policyStore } : MyPolicyObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [tab, setTab] = useState<number>(0);
  const [allPolicy, setAllPolicy] = useState([]);
  const [currentListPolicy, setCurrentListPolicy] = useState([]);

  const listTab = useMemo(() => {
    return [
      { name: t('active') }, { name: t('lapsed') }, { name: t('all') }
    ]
  }, [t]);

  useEffect(() => {
    if(!policyStore?.fromScreen){
      policyStore?.getListAllPolicy(null, "MY_POLICY");
    }
  }, [policyStore, t]);

  useEffect(() => {
    setAllPolicy(policyStore.listPolicy ?? []);
    setCurrentListPolicy(policyStore?.listPolicy?.filter(policy => policy.policyStatus == t('active_1')) ?? []);
  }, [policyStore.listPolicy, t]);

  const _handleClose = () => {
    history.push("/");
  };

  const _handleBack = () => {
    history.push("/");  
  };
  
  const _handleChangeTab = (tabIndex: number) => {
    setTab(tabIndex);
    if(tabIndex == 2){
      setCurrentListPolicy(allPolicy);
    }else if(tabIndex == 0){
      setCurrentListPolicy(allPolicy.filter(policy => policy.policyStatus == t('active_1')));
    }else {
      setCurrentListPolicy(allPolicy.filter(policy => policy.policyStatus == t('lapsed')));
    }
  };

  return (
    <div className="screen-container bg-background ct-view fix-scroll">
      <Toolbar
        title={t('search_policy_info')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <div className={"max-w-md mx-auto my-policy" + (currentListPolicy.length > 0 ? " screenScrollContainer" : "")}>
        <div className="bg-surface pb-2 mt-4 buyer_info">
          <div className='px-4 border border-line'>
            <div className="pt-4 pb-4 text-base font-bold text-onSurface">
              {t('insurance_buyer_info')}
            </div>
          </div>
          <div className='px-4'>
            <div className="mt-5 mb-5">
              <InfoItem
                title={t('identify_card_type')}
                content={UserInfoService.getUserInfo()?.idCardType || t('identify_card_number_1')}
              />
            </div>
            <div className="mb-5">
              <InfoItem
                title={t('identify_card_number')}
                content={UserInfoService.getUserInfo()?.idCardNo || ''}
              />
            </div>
          </div>
        </div>

        <div className="bg-surface px-4 pt-4 pb-4 mt-4 border-b border-line">
          <div className="text-base font-bold text-onSurface">
            {`${t('list_policy')} (${allPolicy.length})`}
          </div>
        </div>
        <div className="bg-surface px-4 pt-4 pb-4 mb-8">
          <div className="mb-5">
            <div className="pb-4">
              <TabBar
                data={listTab}
                activeTab={tab}
                onChangeTab={_handleChangeTab}
                scrollable={true}
                classes={['my-policy-tabItemActive', 'my-policy-tabItemInactive']}
              />
            </div>
            <div>
              {currentListPolicy.length > 0 ? currentListPolicy.map((policy, index) => 
                <div className='pb-4' key={index}><PolicyCard policy={policy} details={CARD_DETAILS} /></div>
              ) : <div className='px-4 pt-4 h-36'>{t('no_policy')}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const MyPolicy = () => <MyPolicyObserver policyStore={policySt} />;
export default MyPolicy;
